import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Transitions from './components/Transitions';
import Header from './components/Header';
import StoryOverview from './components/StoryOverview';
import Videos from './components/Videos';
import Newsletter from './components/Newsletter';
import AudioPlayer from './components/AudioPlayer';
import Collapse from './components/Collapse';
import CopyToClipboard from './components/CopyToClipboard';
import TimeAgo from './components/TimeAgo';
import Footnotes from './components/Footnotes';
import SocialDropdowns from './components/SocialDropdowns';
import InlineAudioPlayers from './components/InlineAudioPlayers';
import Forms from './components/Forms';
import BackToTop from './components/BackToTop';
import GlassCredits from './components/GlassCredits';
import SetViewheight from './components/SetViewheight';
import StoryCards from './components/StoryCards';

// Zorgt ervoor dat de scroll positie niet onthouden wordt
if ('scrollRestoration' in history) {
	history.scrollRestoration = 'manual';
}

if(navigator.serviceWorker){
	// Service worker for video buffering
	navigator.serviceWorker
		.register('/video-buffer-service-worker.js')
		.then((registration) => registration.update())
		.catch(console.log);
}

class Emergence {
	constructor() {
		Promise.all([Emergence.domReady]).then(() => this.init());
	}

	init() {
		this.header = new Header();
		new StoryOverview(this.header);
		new Videos();
		new Newsletter();
		new AudioPlayer();
		new Collapse();
		new CopyToClipboard();
		new TimeAgo();
		new Footnotes();
		new InlineAudioPlayers();
		new SocialDropdowns();
		new Forms();
		new Transitions();
		new BackToTop();
		new GlassCredits();
		new SetViewheight();
		new StoryCards();
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Emergence();
